import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchNoteSummary, selectNoteSummary } from "../features/notes/note.slice";

const useNoteSummary = () => {
    const dispatch = useAppDispatch();
    const summary = useAppSelector(selectNoteSummary);

    const getNoteSummary = async () => {
        await dispatch(fetchNoteSummary());
    }

    useEffect(() => {
        getNoteSummary();
    }, []);

    return summary;
}
 
export default useNoteSummary;